import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

interface SatisfactionData {
  media: number;
  totalRespostas: number;
  nps: number;
  detratores: number;
  neutros: number;
  promotores: number;
}

export function ChatSatisfactionPanel() {
  const [data, setData] = useState<SatisfactionData | null>(null);

  useEffect(() => {
    api.get('/chat-interno/satisfacao').then((res) => setData(res.data));
  }, []);

  if (!data) return <div className="p-4 text-sm text-muted-foreground">Carregando satisfação...</div>;

  return (
    <div className="ac-chat-command-grid">
      <div className="ac-chat-command-card"><p className="ac-chat-command-label">Média</p><h3 className="ac-chat-command-value">{data.media.toFixed(1)}</h3></div>
      <div className="ac-chat-command-card"><p className="ac-chat-command-label">NPS</p><h3 className="ac-chat-command-value">{data.nps}</h3></div>
      <div className="ac-chat-command-card"><p className="ac-chat-command-label">Respostas</p><h3 className="ac-chat-command-value">{data.totalRespostas}</h3></div>
      <div className="ac-chat-command-card"><p className="ac-chat-command-label">Promotores</p><h3 className="ac-chat-command-value">{data.promotores}</h3></div>
    </div>
  );
}
